import React, {useCallback, useEffect, useState} from "react"
import {Button, Grid, TextField, Box} from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarFilterButton, GridToolbarQuickFilter
} from "@mui/x-data-grid";
import moment from "moment";
import { makeStyles, Typography } from "@material-ui/core";
import { formatNumbersToLongFormat } from "../util/constant";
import {postData} from "../util/__fetch";

const useStyles = makeStyles(theme => ({
  menuItem: {
    display: 'block',
    blockSize: 'auto'
  },
  profit: {
    color: 'green'
  },
  loss: {
    color: 'red'
  },
  marketScore: {
    backgroundColor: '#1976d2',
    color: 'white'
  },
  missingEntryCell: {
      backgroundColor: "orange", width: '100%', height: '100%',  display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
  },
  failedEntryCell: {
      backgroundColor: "red", width: '100%', height: '100%',  display: 'flex', color: 'white',
        alignItems: 'center',
        justifyContent: 'center'
  }
}))

const FNOStraddle = ({ user, setOpen, wm }) => {
  const history = useHistory()
  const [straddles, setStraddles] = useState([])
  const [refreshButtonState, setRefreshButtonState] = useState("Stop")
  const classes = useStyles();
  const [exitPercentage, setExitPercentage] = useState(100)

  function CustomToolbar() {
    return (
      <GridToolbarContainer title="Data" sx={{ justifyContent: 'space-between' }}>
        <Typography variant="h6">Open Trades</Typography>
        <Button onClick={reWatch}>Reload Memory</Button>
        <Button color="secondary" onClick={toggleRefresh} value={refreshButtonState}>{refreshButtonState} Refresh Table</Button>
        <GridToolbarFilterButton />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }
  const getClassName = (params, field) => {
    return params.field === field && Number(params.value) > 0 ? classes.profit : classes.loss;
  }

  const toggleRefresh = (event) => {
    if (event.target.value === "Stop") {
      setRefreshButtonState("Start")
    }
    else {
      setRefreshButtonState("Stop")
    }
  }
 const getStrikeStatusClassName = (strikeStatus) => {
     return strikeStatus === "MISSING" ? classes.missingEntryCell : strikeStatus === "FAILED" ? classes.failedEntryCell : ''
  }
  const squareOffStraddle = (straddleId) => {
    fetch(`/algo-trading/api/fno/square-off-straddle/${straddleId}/${exitPercentage}`, {
      method: 'POST',
      headers: {
        'Authorization': user.credential,
        "Content-Type": "application/json",
      }
    }).then(function (response) {
      response.text().then(r => {
        console.log(r);
        wm(r)
        setOpen(true)
      })
    }, function (error) {
      console.log(error.message)
      wm(error.message)
      setOpen(true)
    })
  }

  const getStraddles = useCallback(() => {
    // console.log('Fetching Straddles');
    fetch('/algo-trading/api/fno/straddles', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': user?.credential
      },
    }
    ).then(async (response) => {
      if (response.status === 401) {
        history.push('/')
        return
      }
      if (response.status >= 400) {
        response.text()
          .then(r => {
            console.error(r)
            wm(r)
            setOpen(true)
          })
        return
      }

      const data = await response.text();
      const straddledData = JSON.parse(data);
      // console.log('Straddles Data:', straddledData);
      setStraddles(straddledData)
    })
  }, [user, history, wm, setOpen]);

  useEffect(() => {
    if (refreshButtonState === "Start") {
      return
    }

    const interval = setInterval(() => {
      getStraddles()
    }, 3000);

    return () => clearInterval(interval);
  }, [user, refreshButtonState, getStraddles]);

  const reWatch = () => {
    fetch('/algo-trading/api/fno/straddle/re-add-watch', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': user?.credential
      },
    }
    ).then(async (response) => {
      if (response.status === 401) {
        history.push('/')
        return
      }
      if (response.status >= 400) {
        response.text()
          .then(r => {
            console.error(r)
            wm(r)
            setOpen(true)
          })
        return
      }
    })
  }
  const markClosedInDB = (straddleId) => {
    postData(`/algo-trading/api/fno/mark-closed/${straddleId}`, user, {},
      (m) => wm(m), () => {}, () => {})
  }
  const columns = [
    { field: 'tag', headerName: 'Tag', width: 190, valueGetter: (params) => params.row?.tag?.replaceAll('FNO_', '')
                                                                                    ?.replaceAll('MANUAL', 'MAN')?.replaceAll('ISH', '') },
    { field: 'userId', headerName: 'User', width: 110 },
    { field: 'sellCe', headerName: 'Sell CE', width: 200, valueGetter: (params) => params.row?.sellCe?.symbol,
        renderCell: ({ row }) => {
                return (
                    <Box className={getStrikeStatusClassName(row?.sellCe?.strikeStatus)}>
                        {row?.sellCe?.symbol}
                    </Box>)
                },
    },
    { field: 'sellPe', headerName: 'Sell PE', width: 200, valueGetter: (params) => params.row?.sellPe?.symbol,
     renderCell: ({ row }) => {
     return (
         <Box className={getStrikeStatusClassName(row?.sellPe?.strikeStatus)}>
             {row?.sellPe?.symbol}
         </Box>
         )
     },
 },
    { field: 'buyCe', headerName: 'Buy CE', width: 200, valueGetter: (params) => params.row?.buyCe?.symbol,
        renderCell: ({ row }) => {
        return (
            <Box className={getStrikeStatusClassName(row?.buyCe?.strikeStatus)}>
                {row?.buyCe?.symbol}
            </Box>
            )
        },
    },
    { field: 'buyPe', headerName: 'Buy PE', width: 200, valueGetter: (params) => params.row?.buyPe?.symbol,
        renderCell: ({ row }) => {
              return (
                  <Box className={getStrikeStatusClassName(row?.buyPe?.strikeStatus)}>
                      {row?.buyPe?.symbol}
                  </Box>
                  )
              },
          },
    { field: 'price', headerName: 'Price', width: 80 },
    { field: 'slPrice', headerName: 'SL Price', width: 80 },
    {
      field: 'pnl', headerName: 'P&L', width: 100,
      valueGetter: (params) => params.row?.pnl ? params.row?.pnl : '',
      valueFormatter: (params) => {
        if (!params?.value) {
          return params?.value;
        }
        return formatNumbersToLongFormat(Number(params?.value));
      }
    },
    {
      field: 'slUpdatedOn', headerName: 'SL Updated Ago', width: 100,
      valueFormatter: (params) => !params?.value ? "" : moment.duration(moment().diff(params?.value)).asMinutes().toFixed(0) + " mins",
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: ({ row }) =>
        <Button onClick={() => squareOffStraddle(row?.id)}>
          Square Off
        </Button>,
    },
    { field: 'sellCeQty', headerName: 'Sell CE Qty', width: 80, valueGetter: (params) => params.row?.sellCe?.quantity ? -params.row?.sellCe?.quantity : "" },
    { field: 'sellPeQty', headerName: 'Sell PE Qty', width: 80, valueGetter: (params) => params.row?.sellPe?.quantity ? -params.row?.sellPe?.quantity : ""},
    { field: 'buyCeQty', headerName: 'Buy CE Qty', width: 80, valueGetter: (params) => params.row?.buyCe?.quantity },
    { field: 'buyPeQty', headerName: 'Buy PE Qty', width: 80, valueGetter: (params) => params.row?.buyPe?.quantity },
    { field: 'id', headerName: 'Id', width: 110, valueGetter: (params) => params.row?.id?.split('-')?.[1] },
    {
      field: "actionMarkClosed",
      headerName: "Action",
      sortable: false,
      renderCell: ({ row }) =>
        <Button onClick={() => markClosedInDB(row?.id)}>
          Mark Closed
        </Button>,
    },
  ];
  return (
    <Grid item>
      <Grid item xs={12} justifySelf="center">
        <TextField label="% Exit" variant="outlined" size="small"
                   defaultValue={100} type="number" style={{ marginBottom: '10px' }}
                   onChange={(e) => setExitPercentage(Number.parseFloat(e.target.value))} />
      </Grid>
      <Grid item>
        <DataGrid
          autoHeight={true}
          getRowId={(row) => row?.id}
          rows={straddles}
          columns={columns}
          slots={{
            toolbar: CustomToolbar
          }}
          initialState={{
            sorting: {
              sortModel: [{ field: 'user', sort: 'asc' }]
            },
            pagination: {
              paginationModel: { page: 0, pageSize: 100 },
            },
          }}
          pageSizeOptions={[50, 100, 200, 500]}
          getCellClassName={(params) => {
            if (params.field !== 'pnl') {
              return '';
            }
            return getClassName(params, 'pnl')
          }}
        />
      </Grid>
    </Grid>
  )
}

export default FNOStraddle